export abstract class HTTPError extends Error {
  public abstract unauthorized: boolean;
  public abstract message: string;
  public abstract response: Record<string, any>;
}
